import axios from "axios";
import {useDispatch} from "react-redux";
import {snackShow} from "./store/snackbarSlice";

import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from "dayjs";
import moment from "moment";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault();

const Utils = {

  getDate:(time= new Date()) =>{
    return moment(time).format('YYYY-MM-DD')
  },
  getTime:(time= new Date()) =>{
    return moment(time).format('YYYY-MM-DD HH:mm')
  },
  getSlicedText:(text, maxLength = 40) =>{
    if(!(typeof text == 'string'))
      return text;
    if(!(typeof maxLength == 'number'))
      maxLength = 40;
    return text?.slice(0, maxLength) + (text?.length > maxLength ? '...' : '')
  },
  goodsDefaultImage:()=>{
    return "/goods/default.png"
  },

  processText:(text)=>{
    text = text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;")
      .replace(/\r?\n/g, '<br>')
      .replace(/\s\s/g,'&nbsp;');

    return text;
  }
}



export default Utils;